<template>
  <div id="app">
    <v-app id="inspire">
      <v-card v-model="show" color="#013777">
        <v-card-title>
          <v-row>
            <v-col cols="12" align="center">
              <h3>
                <font color="white">
                  COPA AMERICA 2024
                </font>
              </h3>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" align="center">
              <v-img max-height="150" max-width="150" src="images/copaamerica.jpg"></v-img>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
      <v-card>
        <v-tabs background-color="blue" dark show-arrows>
          <v-tabs-slider color="#FFEBEE"></v-tabs-slider>
          <v-tab> Fixture </v-tab>
          <v-tab> Posiciones por Grupo </v-tab>
          <v-tab> Ranking </v-tab>

          <v-tab-item>
            <!-- <h6>Grupo A</h6>
            <v-row dense v-for="item in increaseA" :key="item">
              <v-col cols="2" md="2" sm="2">
                <v-subheader class=".caption">{{
                  partidosA[item].fecha
                }}</v-subheader>
              </v-col>
              <v-col cols="1" md="1" sm="1">
                <v-subheader class=".caption">
                  {{ partidosA[item].hora }}
                </v-subheader>
              </v-col>
              <v-col cols="3" md="3" sm="3">
                <v-subheader class=".caption">{{
                  partidosA[item].sede
                }}</v-subheader>
              </v-col>
              <v-col cols="2" md="2" sm="2">
                <v-subheader class=".caption">
                  <v-img
                    :src="'images/' + partidosA[item].equipo1 + '.jpg'"
                    max-height="20"
                    max-width="20"
                  ></v-img>

                  {{ partidosA[item].equipo1 }}
                </v-subheader>
              </v-col>
              <v-col cols="1" md="1" sm="1">
                <v-subheader class=".caption">
                  {{ partidosA[item].goles1 }}
                </v-subheader>
              </v-col>
              <v-col cols="1" md="1" sm="1">
                <v-subheader class=".caption">
                  {{ partidosA[item].goles2 }}</v-subheader
                >
              </v-col>
              <v-col cols="2" md="2" sm="2">
                <v-subheader class=".caption">
                  <v-img
                    :src="'images/' + partidosA[item].equipo2 + '.jpg'"
                    max-height="20"
                    max-width="20"
                  ></v-img
                  >{{ partidosA[item].equipo2 }}</v-subheader
                >
              </v-col>
            </v-row> -->
            <v-data-table :headers="headersA" :items="partidosA" locale="es-ar" class="elevation-1" :items-per-page="8"
              hide-default-footer dense>
              <template v-slot:top>
                <v-toolbar flat dense>
                  <v-toolbar-title center>
                    <font color="Red">
                      GRUPO A
                    </font>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
            </v-data-table>
            <v-data-table :headers="headersB" :items="partidosB" locale="es-ar" class="elevation-1" :items-per-page="8"
              hide-default-footer dense>
              <template v-slot:top>
                <v-toolbar flat dense>
                  <v-toolbar-title center>
                    <font color="Red">
                      GRUPO B
                    </font>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
              <!-- <template v-slot:item.equipo1="{ item }">
                <div class="justify-content: right">
                  {{ item.equipo1 }}
                  <p>
                    <v-img
                      :src="'images/' + item.equipo1 + '.jpg'"
                      max-height="20"
                      max-width="20"
                      class="justify-content: right"
                    ></v-img>
                  </p>
                </div>
              </template>
              <template v-slot:item.equipo2="{ item }">
                <div class="justify-content: space-between;">
                  {{ item.equipo2 }}
                  <v-img
                    :src="'images/' + item.equipo2 + '.jpg'"
                    max-height="20"
                    max-width="20"
                  ></v-img>
                </div>
              </template> -->
            </v-data-table>
            <v-data-table :headers="headersC" :items="partidosC" locale="es-ar" class="elevation-1" :items-per-page="8"
              hide-default-footer dense>
              <template v-slot:top>
                <v-toolbar flat dense>
                  <v-toolbar-title center>
                    <font color="Red">
                      GRUPO C
                    </font>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
            </v-data-table>
            <v-data-table :headers="headersD" :items="partidosD" locale="es-ar" class="elevation-1" :items-per-page="8"
              hide-default-footer dense>
              <template v-slot:top>
                <v-toolbar flat dense>
                  <v-toolbar-title center>
                    <font color="Red">
                      GRUPO D
                    </font>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
            </v-data-table>
            <!-- <v-data-table
              :headers="headersE"
              :items="partidosE"
              locale="es-ar"
              class="elevation-1"
              :items-per-page="8"
              hide-default-footer
              dense
            >
              <template v-slot:top>
                <v-toolbar flat dense>
                  <v-toolbar-title center>
                    <font color="Red">
                      GRUPO E
                    </font>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
            </v-data-table>
            <v-data-table
              :headers="headersF"
              :items="partidosF"
              locale="es-ar"
              class="elevation-1"
              :items-per-page="8"
              hide-default-footer
              dense
            >
              <template v-slot:top>
                <v-toolbar flat dense>
                  <v-toolbar-title center>
                    <font color="Red">
                      GRUPO F
                    </font>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
            </v-data-table>
            <v-data-table
              :headers="headersG"
              :items="partidosG"
              locale="es-ar"
              class="elevation-1"
              :items-per-page="8"
              hide-default-footer
              dense
            >
              <template v-slot:top>
                <v-toolbar flat dense>
                  <v-toolbar-title center>
                    <font color="Red">
                      GRUPO G
                    </font>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
            </v-data-table>
            <v-data-table
              :headers="headersH"
              :items="partidosH"
              locale="es-ar"
              class="elevation-1"
              :items-per-page="8"
              hide-default-footer
              dense
            >
              <template v-slot:top>
                <v-toolbar flat dense>
                  <v-toolbar-title center>
                    <font color="Red">
                      GRUPO H
                    </font>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
            </v-data-table> -->
          </v-tab-item>
          <v-tab-item>
            <v-data-table :headers="headersPA" :items="posicionA" locale="es-ar" class="elevation-1" :items-per-page="8"
              hide-default-footer dense>
              <template v-slot:top>
                <v-toolbar flat dense>
                  <v-toolbar-title center>
                    <font color="Red">
                      GRUPO A
                    </font>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
            </v-data-table>
            <v-data-table :headers="headersPB" :items="posicionB" locale="es-ar" class="elevation-1" :items-per-page="8"
              hide-default-footer dense>
              <template v-slot:top>
                <v-toolbar flat dense>
                  <v-toolbar-title center>
                    <font color="Red">
                      GRUPO B
                    </font>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
            </v-data-table>
            <v-data-table :headers="headersPC" :items="posicionC" locale="es-ar" class="elevation-1" :items-per-page="8"
              hide-default-footer dense>
              <template v-slot:top>
                <v-toolbar flat dense>
                  <v-toolbar-title center>
                    <font color="Red">
                      GRUPO C
                    </font>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
            </v-data-table>
            <v-data-table :headers="headersPD" :items="posicionD" locale="es-ar" class="elevation-1" :items-per-page="8"
              hide-default-footer dense>
              <template v-slot:top>
                <v-toolbar flat dense>
                  <v-toolbar-title center>
                    <font color="Red">
                      GRUPO D
                    </font>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
            </v-data-table>
            <!-- <v-data-table
              :headers="headersPE"
              :items="posicionE"
              locale="es-ar"
              class="elevation-1"
              :items-per-page="8"
              hide-default-footer
              dense
            >
              <template v-slot:top>
                <v-toolbar flat dense>
                  <v-toolbar-title center>
                    <font color="Red">
                      GRUPO E
                    </font>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
            </v-data-table>
            <v-data-table
              :headers="headersPF"
              :items="posicionF"
              locale="es-ar"
              class="elevation-1"
              :items-per-page="8"
              hide-default-footer
              dense
            >
              <template v-slot:top>
                <v-toolbar flat dense>
                  <v-toolbar-title center>
                    <font color="Red">
                      GRUPO F
                    </font>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
            </v-data-table>
            <v-data-table
              :headers="headersPG"
              :items="posicionG"
              locale="es-ar"
              class="elevation-1"
              :items-per-page="8"
              hide-default-footer
              dense
            >
              <template v-slot:top>
                <v-toolbar flat dense>
                  <v-toolbar-title center>
                    <font color="Red">
                      GRUPO G
                    </font>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
            </v-data-table>
            <v-data-table
              :headers="headersPH"
              :items="posicionH"
              locale="es-ar"
              class="elevation-1"
              :items-per-page="8"
              hide-default-footer
              dense
            >
              <template v-slot:top>
                <v-toolbar flat dense>
                  <v-toolbar-title center>
                    <font color="Red">
                      GRUPO H
                    </font>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
            </v-data-table> -->
          </v-tab-item>
          <v-tab-item>
            <v-card max-width="600" align="center">
              <v-data-table :headers="headersR" :items="ranking" locale="es-ar" class="elevation-1"
                :items-per-page="135" hide-default-footer dense>
                <template v-slot:top>
                  <v-toolbar flat dense>
                    <v-toolbar-title center>
                      <font color="Red">
                        RANKING
                      </font>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small color="blue" class="mr-2" v-on="on" v-bind="attrs" @click.stop="verProde(item)">
                        mdi-eye
                      </v-icon>
                    </template>
                    <span>ver prode</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card>
      <VerProde :visible="showProde" :legajo="editedItem.legajo" @close="showProde = false"></VerProde>
    </v-app>
  </div>
</template>

<script>
import axios from "../../../axios-auth";
import moment from "moment";
//import UploadService from "../../services/UploadFilesService";
import Compressor from "compressorjs";
import VerProde from "../Prode/Informe.vue";

export default {
  components: { VerProde },
  data: (vm) => ({
    valid: false,
    lazy: false,
    showProde: false,
    editedItem: {},
    editedIndex: -1,
    //increase: [0, 6, 12, 18, 24, 30, 36, 42],
    increase: [0, 6, 12, 18],
    //increaseA: [0, 1, 2, 3, 4, 5],
    increaseA: [0, 1, 2, 3],
    //items: ["A", "B", "C", "D", "E", "F", "G", "H"],
    items: ["A", "B", "C", "D"],
    partidosA: [],
    partidosB: [],
    partidosC: [],
    partidosD: [],
    partidosE: [],
    partidosF: [],
    partidosG: [],
    partidosH: [],
    posicionA: [],
    posicionB: [],
    posicionC: [],
    posicionD: [],
    posicionE: [],
    posicionF: [],
    posicionG: [],
    posicionH: [],
    ranking: [],
    headersA: [
      {
        text: "Código",
        width: "5%",
        align: "center",
        sortable: false,
        value: "idresultado",
      },
      { text: "Fecha", width: "8%", value: "fecha", sortable: false },
      { text: "Hora", width: "7%", value: "hora", sortable: false },
      { text: "Sede", width: "30%", value: "sede", sortable: false },
      {
        text: "Equipo",
        width: "20%",
        value: "equipo1",
        align: "right",
        sortable: false,
      },
      {
        text: "",
        width: "5%",
        align: "center",
        value: "goles1",
        sortable: false,
      },
      {
        text: "",
        width: "5%",
        align: "center",
        value: "goles2",
        sortable: false,
      },
      { text: "Equipo", width: "20%", value: "equipo2", sortable: false },
    ],
    headersB: [
      {
        text: "Código",
        width: "5%",
        align: "center",
        sortable: false,
        value: "idresultado",
      },
      { text: "Fecha", width: "8%", value: "fecha", sortable: false },
      { text: "Hora", width: "7%", value: "hora", sortable: false },
      { text: "Sede", width: "30%", value: "sede", sortable: false },
      {
        text: "Equipo",
        width: "20%",
        value: "equipo1",
        align: "right",
        sortable: false,
      },
      {
        text: "",
        width: "5%",
        align: "center",
        value: "goles1",
        sortable: false,
      },
      {
        text: "",
        width: "5%",
        align: "center",
        value: "goles2",
        sortable: false,
      },
      { text: "Equipo", width: "20%", value: "equipo2", sortable: false },
    ],
    headersC: [
      {
        text: "Código",
        width: "5%",
        align: "center",
        sortable: false,
        value: "idresultado",
      },
      { text: "Fecha", width: "8%", value: "fecha", sortable: false },
      { text: "Hora", width: "7%", value: "hora", sortable: false },
      { text: "Sede", width: "30%", value: "sede", sortable: false },
      {
        text: "Equipo",
        width: "20%",
        value: "equipo1",
        align: "right",
        sortable: false,
      },
      {
        text: "",
        width: "5%",
        align: "center",
        value: "goles1",
        sortable: false,
      },
      {
        text: "",
        width: "5%",
        align: "center",
        value: "goles2",
        sortable: false,
      },
      { text: "Equipo", width: "20%", value: "equipo2", sortable: false },
    ],
    headersD: [
      {
        text: "Código",
        width: "5%",
        align: "center",
        sortable: false,
        value: "idresultado",
      },
      { text: "Fecha", width: "8%", value: "fecha", sortable: false },
      { text: "Hora", width: "7%", value: "hora", sortable: false },
      { text: "Sede", width: "30%", value: "sede", sortable: false },
      {
        text: "Equipo",
        width: "20%",
        value: "equipo1",
        align: "right",
        sortable: false,
      },
      {
        text: "",
        width: "5%",
        align: "center",
        value: "goles1",
        sortable: false,
      },
      {
        text: "",
        width: "5%",
        align: "center",
        value: "goles2",
        sortable: false,
      },
      { text: "Equipo", width: "20%", value: "equipo2", sortable: false },
    ],
    headersE: [
      {
        text: "Código",
        width: "5%",
        align: "center",
        sortable: false,
        value: "idresultado",
      },
      { text: "Fecha", width: "8%", value: "fecha", sortable: false },
      { text: "Hora", width: "7%", value: "hora", sortable: false },
      { text: "Sede", width: "30%", value: "sede", sortable: false },
      {
        text: "Equipo",
        width: "20%",
        value: "equipo1",
        align: "right",
        sortable: false,
      },
      {
        text: "",
        width: "5%",
        align: "center",
        value: "goles1",
        sortable: false,
      },
      {
        text: "",
        width: "5%",
        align: "center",
        value: "goles2",
        sortable: false,
      },
      { text: "Equipo", width: "20%", value: "equipo2", sortable: false },
    ],
    headersF: [
      {
        text: "Código",
        width: "5%",
        align: "center",
        sortable: false,
        value: "idresultado",
      },
      { text: "Fecha", width: "8%", value: "fecha", sortable: false },
      { text: "Hora", width: "7%", value: "hora", sortable: false },
      { text: "Sede", width: "30%", value: "sede", sortable: false },
      {
        text: "Equipo",
        width: "20%",
        value: "equipo1",
        align: "right",
        sortable: false,
      },
      {
        text: "",
        width: "5%",
        align: "center",
        value: "goles1",
        sortable: false,
      },
      {
        text: "",
        width: "5%",
        align: "center",
        value: "goles2",
        sortable: false,
      },
      { text: "Equipo", width: "20%", value: "equipo2", sortable: false },
    ],
    headersG: [
      {
        text: "Código",
        width: "5%",
        align: "center",
        sortable: false,
        value: "idresultado",
      },
      { text: "Fecha", width: "8%", value: "fecha", sortable: false },
      { text: "Hora", width: "7%", value: "hora", sortable: false },
      { text: "Sede", width: "30%", value: "sede", sortable: false },
      {
        text: "Equipo",
        width: "20%",
        value: "equipo1",
        align: "right",
        sortable: false,
      },
      {
        text: "",
        width: "5%",
        align: "center",
        value: "goles1",
        sortable: false,
      },
      {
        text: "",
        width: "5%",
        align: "center",
        value: "goles2",
        sortable: false,
      },
      { text: "Equipo", width: "20%", value: "equipo2", sortable: false },
    ],
    headersH: [
      {
        text: "Código",
        width: "5%",
        align: "center",
        sortable: false,
        value: "idresultado",
      },
      { text: "Fecha", width: "8%", value: "fecha", sortable: false },
      { text: "Hora", width: "7%", value: "hora", sortable: false },
      { text: "Sede", width: "30%", value: "sede", sortable: false },
      {
        text: "Equipo",
        width: "20%",
        value: "equipo1",
        align: "right",
        sortable: false,
      },
      {
        text: "",
        width: "5%",
        align: "center",
        value: "goles1",
        sortable: false,
      },
      {
        text: "",
        width: "5%",
        align: "center",
        value: "goles2",
        sortable: false,
      },
      { text: "Equipo", width: "20%", value: "equipo2", sortable: false },
    ],
    headersPA: [
      {
        text: "Equipo",
        width: "15%",
        align: "center",
        value: "nombre",
        sortable: false,
      },
      {
        text: "Puntaje",
        width: "5%",
        align: "center",
        value: "puntaje",
        sortable: false,
      },
      {
        text: "Partidos Jugados",
        width: "5%",
        align: "center",
        value: "pj",
        sortable: false,
      },
      {
        text: "Partidos Ganados",
        width: "5%",
        align: "center",
        value: "pg",
        sortable: false,
      },
      {
        text: "Partidos Empatados",
        width: "5%",
        align: "center",
        value: "pe",
        sortable: false,
      },
      {
        text: "Partidos Perdidos",
        width: "5%",
        align: "center",
        value: "pp",
        sortable: false,
      },
      {
        text: "Goles a Favor",
        width: "5%",
        align: "center",
        value: "gf",
        sortable: false,
      },
      {
        text: "Goles en contra",
        width: "5%",
        align: "center",
        value: "gc",
        sortable: false,
      },
    ],
    headersPB: [
      {
        text: "Equipo",
        width: "15%",
        align: "center",
        value: "nombre",
        sortable: false,
      },
      {
        text: "Puntaje",
        width: "5%",
        align: "center",
        value: "puntaje",
        sortable: false,
      },
      {
        text: "Partidos Jugados",
        width: "5%",
        align: "center",
        value: "pj",
        sortable: false,
      },
      {
        text: "Partidos Ganados",
        width: "5%",
        align: "center",
        value: "pg",
        sortable: false,
      },
      {
        text: "Partidos Empatados",
        width: "5%",
        align: "center",
        value: "pe",
        sortable: false,
      },
      {
        text: "Partidos Perdidos",
        width: "5%",
        align: "center",
        value: "pp",
        sortable: false,
      },
      {
        text: "Goles a Favor",
        width: "5%",
        align: "center",
        value: "gf",
        sortable: false,
      },
      {
        text: "Goles en contra",
        width: "5%",
        align: "center",
        value: "gc",
        sortable: false,
      },
    ],
    headersPC: [
      {
        text: "Equipo",
        width: "15%",
        align: "center",
        value: "nombre",
        sortable: false,
      },
      {
        text: "Puntaje",
        width: "5%",
        align: "center",
        value: "puntaje",
        sortable: false,
      },
      {
        text: "Partidos Jugados",
        width: "5%",
        align: "center",
        value: "pj",
        sortable: false,
      },
      {
        text: "Partidos Ganados",
        width: "5%",
        align: "center",
        value: "pg",
        sortable: false,
      },
      {
        text: "Partidos Empatados",
        width: "5%",
        align: "center",
        value: "pe",
        sortable: false,
      },
      {
        text: "Partidos Perdidos",
        width: "5%",
        align: "center",
        value: "pp",
        sortable: false,
      },
      {
        text: "Goles a Favor",
        width: "5%",
        align: "center",
        value: "gf",
        sortable: false,
      },
      {
        text: "Goles en contra",
        width: "5%",
        align: "center",
        value: "gc",
        sortable: false,
      },
    ],
    headersPD: [
      {
        text: "Equipo",
        width: "15%",
        align: "center",
        value: "nombre",
        sortable: false,
      },
      {
        text: "Puntaje",
        width: "5%",
        align: "center",
        value: "puntaje",
        sortable: false,
      },
      {
        text: "Partidos Jugados",
        width: "5%",
        align: "center",
        value: "pj",
        sortable: false,
      },
      {
        text: "Partidos Ganados",
        width: "5%",
        align: "center",
        value: "pg",
        sortable: false,
      },
      {
        text: "Partidos Empatados",
        width: "5%",
        align: "center",
        value: "pe",
        sortable: false,
      },
      {
        text: "Partidos Perdidos",
        width: "5%",
        align: "center",
        value: "pp",
        sortable: false,
      },
      {
        text: "Goles a Favor",
        width: "5%",
        align: "center",
        value: "gf",
        sortable: false,
      },
      {
        text: "Goles en contra",
        width: "5%",
        align: "center",
        value: "gc",
        sortable: false,
      },
    ],
    headersPE: [
      {
        text: "Equipo",
        width: "15%",
        align: "center",
        value: "nombre",
        sortable: false,
      },
      {
        text: "Puntaje",
        width: "5%",
        align: "center",
        value: "puntaje",
        sortable: false,
      },
      {
        text: "Partidos Jugados",
        width: "5%",
        align: "center",
        value: "pj",
        sortable: false,
      },
      {
        text: "Partidos Ganados",
        width: "5%",
        align: "center",
        value: "pg",
        sortable: false,
      },
      {
        text: "Partidos Empatados",
        width: "5%",
        align: "center",
        value: "pe",
        sortable: false,
      },
      {
        text: "Partidos Perdidos",
        width: "5%",
        align: "center",
        value: "pp",
        sortable: false,
      },
      {
        text: "Goles a Favor",
        width: "5%",
        align: "center",
        value: "gf",
        sortable: false,
      },
      {
        text: "Goles en contra",
        width: "5%",
        align: "center",
        value: "gc",
        sortable: false,
      },
    ],
    headersPF: [
      {
        text: "Equipo",
        width: "15%",
        align: "center",
        value: "nombre",
        sortable: false,
      },
      {
        text: "Puntaje",
        width: "5%",
        align: "center",
        value: "puntaje",
        sortable: false,
      },
      {
        text: "Partidos Jugados",
        width: "5%",
        align: "center",
        value: "pj",
        sortable: false,
      },
      {
        text: "Partidos Ganados",
        width: "5%",
        align: "center",
        value: "pg",
        sortable: false,
      },
      {
        text: "Partidos Empatados",
        width: "5%",
        align: "center",
        value: "pe",
        sortable: false,
      },
      {
        text: "Partidos Perdidos",
        width: "5%",
        align: "center",
        value: "pp",
        sortable: false,
      },
      {
        text: "Goles a Favor",
        width: "5%",
        align: "center",
        value: "gf",
        sortable: false,
      },
      {
        text: "Goles en contra",
        width: "5%",
        align: "center",
        value: "gc",
        sortable: false,
      },
    ],
    headersPG: [
      {
        text: "Equipo",
        width: "15%",
        align: "center",
        value: "nombre",
        sortable: false,
      },
      {
        text: "Puntaje",
        width: "5%",
        align: "center",
        value: "puntaje",
        sortable: false,
      },
      {
        text: "Partidos Jugados",
        width: "5%",
        align: "center",
        value: "pj",
        sortable: false,
      },
      {
        text: "Partidos Ganados",
        width: "5%",
        align: "center",
        value: "pg",
        sortable: false,
      },
      {
        text: "Partidos Empatados",
        width: "5%",
        align: "center",
        value: "pe",
        sortable: false,
      },
      {
        text: "Partidos Perdidos",
        width: "5%",
        align: "center",
        value: "pp",
        sortable: false,
      },
      {
        text: "Goles a Favor",
        width: "5%",
        align: "center",
        value: "gf",
        sortable: false,
      },
      {
        text: "Goles en contra",
        width: "5%",
        align: "center",
        value: "gc",
        sortable: false,
      },
    ],
    headersPH: [
      {
        text: "Equipo",
        width: "15%",
        align: "center",
        value: "nombre",
        sortable: false,
      },
      {
        text: "Puntaje",
        width: "5%",
        align: "center",
        value: "puntaje",
        sortable: false,
      },
      {
        text: "Partidos Jugados",
        width: "5%",
        align: "center",
        value: "pj",
        sortable: false,
      },
      {
        text: "Partidos Ganados",
        width: "5%",
        align: "center",
        value: "pg",
        sortable: false,
      },
      {
        text: "Partidos Empatados",
        width: "5%",
        align: "center",
        value: "pe",
        sortable: false,
      },
      {
        text: "Partidos Perdidos",
        width: "5%",
        align: "center",
        value: "pp",
        sortable: false,
      },
      {
        text: "Goles a Favor",
        width: "5%",
        align: "center",
        value: "gf",
        sortable: false,
      },
      {
        text: "Goles en contra",
        width: "5%",
        align: "center",
        value: "gc",
        sortable: false,
      },
    ],
    headersR: [
      {
        text: "Legajo",
        width: "20%",
        align: "center",
        value: "legajo",
        sortable: false,
      },
      {
        text: "Nombre",
        width: "50%",
        align: "center",
        value: "nombre",
        sortable: false,
      },
      {
        text: "Puntaje",
        width: "20%",
        align: "center",
        value: "puntos",
        sortable: false,
      },
      {
        text: "Ver",
        width: "10%",
        align: "center",
        value: "actions",
        sortable: false,
      },
    ],
    fecha: moment().format("DD/MM/YYYY"),
    //increase: [0, 6, 12, 18, 24, 30, 36, 42],
    //items: ["A", "B", "C", "D", "E", "F", "G", "H"],
    increase: [0, 6, 12, 18],
    items: ["A", "B", "C", "D"],
    equipos: [],
    prode: [],
    idresultados: [],
  }),
  // watch: {
  //   select: function(val) {
  //     this.cargarResultadoLegajo();
  //   },
  // },
  computed: {
    show: {
      get() {
        this.responsable = this.$store.state.nombre.toString().trim();
        this.cargarResultado();
        this.cargarPosiciones();
        this.cargarRanking();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          this.$emit("close");
        }
      },
    },
    isActive() {
      return false;
    },
  },

  methods: {
    cargarResultado() {
      let self = this;
      axios
        .get("/App/GetProdeResultados?")
        .then((response) => {
          response.data.forEach((element) => {
            if (element.idresultado <= "6") {
              self.partidosA.push(element);
            }
            if (element.idresultado >= "7" && element.idresultado <= "12") {
              self.partidosB.push(element);
            }
            if (element.idresultado >= "13" && element.idresultado <= "18") {
              self.partidosC.push(element);
            }
            if (element.idresultado >= "19" && element.idresultado <= "24") {
              self.partidosD.push(element);
            }
            // if (element.idresultado >= "25" && element.idresultado <= "30") {
            //   self.partidosE.push(element);
            // }
            // if (element.idresultado >= "31" && element.idresultado <= "36") {
            //   self.partidosF.push(element);
            // }
            // if (element.idresultado >= "37" && element.idresultado <= "42") {
            //   self.partidosG.push(element);
            // }
            // if (element.idresultado >= "43" && element.idresultado <= "48") {
            //   self.partidosH.push(element);
            // }
          });
        })
        .catch((error) => {
          self.equipos = [];
          console.log(error);
        });
    },
    cargarPosiciones() {
      let self = this;
      axios
        .get("/App/GetProdePosiciones?")
        .then((response) => {
          response.data.forEach((element) => {
            if (element.grupo == "A") {
              self.posicionA.push(element);
            }
            if (element.grupo == "B") {
              self.posicionB.push(element);
            }
            if (element.grupo == "C") {
              self.posicionC.push(element);
            }
            if (element.grupo == "D") {
              self.posicionD.push(element);
            }
            // if (element.grupo == "E") {
            //   self.posicionE.push(element);
            // }
            // if (element.grupo == "F") {
            //   self.posicionF.push(element);
            // }
            // if (element.grupo == "G") {
            //   self.posicionG.push(element);
            // }
            // if (element.grupo == "H") {
            //   self.posicionH.push(element);
            // }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    cargarRanking() {
      let self = this;
      axios
        .get("/App/GetProdeRanking?")
        .then((response) => {
          self.ranking = response.data;
        })
        .catch((error) => {
          self.ranking = [];
          console.log(error);
        });
    },

    verProde(item) {
      this.editedIndex = this.ranking.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showProde = true;
    },
  },
};
</script>
